import { gql } from '@apollo/client';

export const EXPORT_PORTAL_PROGRAMMES = gql`
  query ExportPortalProgrammes($input: ExportArgs) {
    exportPortalProgrammes(input: $input) {
      id
      fromDate
      toDate
      name
      summary
      theoryOfChange
    }
  }
`;
